<button
  qai-button
  size="small"
  kind="tertiary"
  shape="circle"
  [disabled]="disabled()"
  [attr.aria-label]="(isScreenSharing() ? 'call.SCREENSHARE_STOP_LABEL' : 'call.SCREENSHARE_LABEL') | transloco"
  (click)="handleClick()"
>
  <svg
    positionStart
    class="icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M4 10v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    @if (isScreenSharing()) {
      <path d="M12 3v11M8 10l4 4 4-4" />
    } @else {
      <path d="M12 14V3M8 7l4-4 4 4" />
    }
  </svg>
</button>
<div class="label">
  {{ (isScreenSharing() ? 'call.SCREENSHARE_STOP_LABEL' : 'call.SCREENSHARE_LABEL') | transloco }}
</div>
